import { setCookie } from "./handleCookie";
export const getSearchParams = (query: URLSearchParams) => {
    const ref = query.get('ref');
    const refSub = query.get('ref_sub');
    const src = query.get('src');
    const coupon = query.get('coupon');
    if (ref) setCookie('ref', ref, 30);
    if (refSub) setCookie('ref_sub', refSub, 30);
    if (src) setCookie('src', src, 30);
    if (coupon) setCookie('coupon', coupon, 30);
    if (!ref) setCookie('ref', coupon, 30);
}